function extract(redactedMetadata, role) {
    const result = {};
    redactedMetadata.namespaces.forEach(ns => {
        result[ns.title] = getRelationsForNamespace(ns, role);
        result[ns.title]._meta = Object.assign({ hNodeType: 'namespace' }, ns);
    });
    return result;
}

/**
 *
 * @param {object} namespace a single namespace object
 * @param {object[]} namespace.relations
 * @param {string} role
 */
function getRelationsForNamespace(namespace, role) {
    const result = {};
    namespace.relations.forEach(rel => {
        result[rel.title] = {
            _meta: Object.assign(rel, {
                hNodeType: 'relation',
                accessContext: getAccessContextForRelation(rel, role)
            })
        };
    });
    return result;
}

/**
 *
 * @param {object} relation
 * @param {string} relation.blockId
 * @param {object[]} relation.methodAccess
 * @param {string} relation.methodAccess[].role
 * @param {boolean} relation.methodAccess[].get
 * @param {boolean} relation.methodAccess[].patch
 * @param {boolean} relation.methodAccess[].post
 * @param {boolean} relation.methodAccess[].remove
 * @param {string} role
 * @returns
 */
function getAccessContextForRelation(relation, role) {
    const observedLocation = relation.blockId;
    if (role === 'DEITY') {
        //deity has all access
        return {
            get: { value: true, observedLocation },
            patch: { value: true, observedLocation },
            post: { value: true, observedLocation },
            put: { value: true, observedLocation },
            remove: { value: true, observedLocation }
        };
    }
    if (relation.methodAccess) {
        const roleAccess = relation.methodAccess.find(ma => ma.role === role);
        //if access is defined, use that
        if (roleAccess) {
            return {
                get: { value: roleAccess.get, observedLocation },
                patch: { value: roleAccess.patch, observedLocation },
                post: { value: roleAccess.post, observedLocation },
                put: { value: roleAccess.put, observedLocation },
                remove: { value: roleAccess.remove, observedLocation }
            };
        }
    }
    //if no access is defined, no access!
    return {
        get: { value: false, observedLocation },
        patch: { value: false, observedLocation },
        post: { value: false, observedLocation },
        put: { value: false, observedLocation },
        remove: { value: false, observedLocation }
    };
}

module.exports = { extract };
